import type { AiAssetReference } from '@modules/content-plan/types';

export type BrandStyleKitReferenceTextBudgetDraft = {
  slot: string;
  textRole: string;
  containerSlot: string;
  label: string;
  recommendedChars: string;
  maxChars: string;
  maxLines: string;
  notes: string;
};

export type BrandStyleKitReferenceDraft = {
  url: string;
  mimeType: string;
  name: string;
  instruction: string;
  role: NonNullable<AiAssetReference['role']>;
  textBudgets?: BrandStyleKitReferenceTextBudgetDraft[];
};

export type BrandStyleKitDraft = {
  designDescription: string;
  primaryColor: string;
  accentColor: string;
  neutralColors: string;
  forbiddenColors: string;
  primaryFontName: string;
  headingStyle: string;
  bodyStyle: string;
  moodKeywords: string;
  imageTreatment: string;
  motionCulture: string;
  compositionGrid: string;
  compositionSpacing: string;
  compositionHierarchy: string;
  illustrationLineWeight: string;
  illustrationShadow: string;
  illustrationTexture: string;
  photoCamera: string;
  photoLighting: string;
  photoBackground: string;
  brandMotifs: string;
  forbiddenVisuals: string;
  textPolicyMode: string;
  exactTextRequired: boolean;
  references: BrandStyleKitReferenceDraft[];
  isComplete: boolean;
};

export function emptyBrandStyleKitDraft(): BrandStyleKitDraft {
  return {
    designDescription: '',
    primaryColor: '',
    accentColor: '',
    neutralColors: '',
    forbiddenColors: '',
    primaryFontName: '',
    headingStyle: '',
    bodyStyle: '',
    moodKeywords: '',
    imageTreatment: '',
    motionCulture: '',
    compositionGrid: '',
    compositionSpacing: '',
    compositionHierarchy: '',
    illustrationLineWeight: '',
    illustrationShadow: '',
    illustrationTexture: '',
    photoCamera: '',
    photoLighting: '',
    photoBackground: '',
    brandMotifs: '',
    forbiddenVisuals: '',
    textPolicyMode: 'render_in_model',
    exactTextRequired: true,
    references: [],
    isComplete: false,
  };
}
